module.exports = __webpack_public_path__ + "public/Icons/content_management.svg?c3b4845b";